import Loadable from 'react-loadable';

import PleaseWait from '~/components/loaders/please-wait';

export default Loadable({
  loader: () => import('./Devoteam'),
  loading: () => <PleaseWait />,
});
